module.exports = __webpack_public_path__ + "img/tu5.c8d3a03c.png";